import { useState, useEffect } from 'react';
import { Impressionable } from '@fiverr-private/impressionable';
import { STATIC_ENRICHMENT } from './constants';

const getImpression = ({ project, enrichment = {} }) => {
    // Active variation marks the first variation the user has saw.
    const activeVariation = project.variations[project.activateVariationIndex || 0];

    const { briefId, pageNumber, gig_impression, page, ...restOfEnrichment } = enrichment;
    const { alg, ...restOfGigImpression } = gig_impression[0];

    return {
        ...STATIC_ENRICHMENT,
        makers_project: {
            id: project.id,
            brief: { id: briefId },
            variation: { id: activeVariation.id },
        },
        seller: { id: project.user_id },
        item_context: {
            position: project.position,
            page_number: pageNumber,
        },
        page,
        gig_impression: {
            ...restOfGigImpression,
            alg: {
                ...alg,
                name: project.algoPool,
            },
            type: project.engineType,
        },
        ...restOfEnrichment,
    };
};

/**
 * Tracks Logo project listings cards impressions
 * @param {Project[]} projects - The listings projects
 * @param {Object} impressionEnrichment - The enrichment to apply on every impression
 * @param {Object} containerRef - Listings container ref
 * @param {String} selector - The impressionable selector attribute
 * @param {String} idAttribute - The impressionable id attribute
 * @returns {Object}
 */
const useImpressions = ({ projects, impressionEnrichment, containerRef, selector, idAttribute }) => {
    const [impressionable, setImpressionable] = useState();

    const handleEnrich = (project) => getImpression({ project, enrichment: impressionEnrichment });

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (!impressionEnrichment) {
            return;
        }

        if (containerRef.current && !impressionable) {
            const impressionable = new Impressionable({
                DOMSelector: selector,
                DOMAttribute: idAttribute,
                container: containerRef.current,
                data: projects.map((project, index) => ({ ...project, position: index + 1 })),
                enrich: handleEnrich,
            });
            setImpressionable(impressionable);
        }

        return () => {
            if (impressionable) {
                impressionable.die();
                setImpressionable();
            }
        };
    }, [containerRef, impressionable, projects.length, impressionEnrichment]);

    return [impressionable];
};

export default useImpressions;
